export default "__VITE_ASSET__B4w$ELns__"